import React, { useEffect, useMemo, useState } from "react";
import usePermission from "../../config/permissions";
import axios from "axios";
import { BASE_URL, TESTING_URL_actual } from "../../config/axios";
import { ToastContainer } from "react-toastify";
import { AddConsultantAccount, UpdateSiteEmployee, UpdateSiteEmployeeDesignation } from "./WorkforceCrudButton"
import { Eye, DocumentIcon, DownloadIcon } from '../AllSvg';
import Modal from "react-bootstrap/Modal";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import '../SiteManagement/ProjectDetailsCSS/milestone.css';
import '../SiteManagement/ProjectDetailsCSS/progress.css';



import {
    AddDepartment,
    AddSiteDepartment,
    AddSiteSubcompanys,
    DeleteSiteDepartment,
    UpdateDepartment,
    DeleteDepartment,
    DeleteSiteSubcompany,
    UpdateSiteDepartment,
    UpdateConsultantAccount,
    DeleteAccountDetails,
    UpdateSiteSubcompanyupdate,


    AddSiteEmployee, UploadSiteEmployee
    , EmployeeDetailCard


} from "./WorkforceCrudButton"

import { CSSForSelect, getCSSForFilterDropdown, handleErrorToast, sortProjects } from "../CustomFunctions";
import { CircularGrid, Location, SearchBig, SearchSmall, Designation, Employee } from "../AllSvg";
import { useLocation } from "react-router-dom";
import { AddSiteAttendence } from "../Attendance";
import { DesignationModern, DivisionModern, Projects, SubCompanyModern } from "../FilterDropdown";
import { UploadDepartment, UploadDesignation } from "../SiteManagement/BulkModals";
import Select from "react-select";
import BulkUpdateEmployee from "../bulkUpdate/UpdateEmployee";
import { Activity, Briefcase, Building2, CheckCircle, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, DownloadCloud, File, FileBadge2, Filter, Search, Tag, UserCog, Users, X, XCircle } from "lucide-react";






const SiteDesignationTable = () => {
    const companyId = sessionStorage.getItem('sitemanagement_project_sub_company');
    const [siteDepartmentList, setSiteDepartmentList] = useState([]);
    const [toggleCompany, setToggleCompany] = useState("null");
    const [buffer, setBuffering] = useState(true);
    const { PERMISSION_AUTHORITY } = usePermission();
    const [siteDivsionList, setsiteDivsionList] = useState([]);
    const role = sessionStorage.getItem('sitemanagement_role');
    const [showFilters, setShowFilters] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    const getSiteDepartment = async () => {
        setBuffering(true);
        try {
            const sub = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${companyId}/`);
            setsiteDivsionList(sub.data);

            const res = await axios.get(
                `${BASE_URL}/siteproject/designationfilterbysubcompanycount/null/active/${companyId}/`
            );
            setSiteDepartmentList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    useEffect(() => {
        getSiteDepartment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggleCompany, companyId]);

    const filteredList = siteDepartmentList
        ?.filter((e) => e.title.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title, "en", { ignorePunctuation: true }));

    const hasActiveFilters = searchQuery !== "";

    const clearAllFilters = () => {
        setSearchQuery("");
    };

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div className="filter-chip-icon"><Search size={13} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <span className="filter-chip-label">Search Designation</span>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Search Designation"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Tag size={14} />
                        <span>Showing</span>
                        <strong>{(filteredList?.length) || 0} designations</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    {role !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddSiteDepartment
                                getSiteDepartment={getSiteDepartment}
                                siteDepartmentList={siteDepartmentList}
                                divisionList={siteDivsionList}
                            />
                            {role === "Admin" && (
                                <UploadDesignation getDesignation={getSiteDepartment} />
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '6%' }}>#</th>
                                <th className="col-period">Designation</th>
                                <th className="col-period text-center">Subcompany</th>
                                <th className="col-period text-center">Division</th>
                                <th className="col-approved text-center" style={{ width: '12%' }}>View Employees</th>
                                {role !== "ViewAccess" && <th className="col-approved text-center" style={{ width: '12%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList?.map((i, index) => (
                                <tr className="progress-row" key={index}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period">
                                        <span className="badge-value">{i.title}</span>
                                    </td>
                                    <td className="col-period text-center">{i.subcompany_name || "-"}</td>
                                    <td className="col-period text-center">{i.division_name || "-"}</td>

                                    <td className="col-approved text-center">
                                        <EmployeebySiteDesignationTable
                                            designationId={i.id}
                                            designation={i}
                                            siteSubCompanyList={siteDivsionList}
                                            getSiteDepartment={getSiteDepartment}
                                        />
                                    </td>
                                    {role !== "ViewAccess" && (
                                        <td className="col-approved text-center">
                                            <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                <UpdateSiteDepartment
                                                    i={i}
                                                    getSiteDepartment={getSiteDepartment}
                                                    siteDepartmentList={siteDepartmentList}
                                                    divisionList={siteDivsionList}
                                                />
                                                {PERMISSION_AUTHORITY && (
                                                    <DeleteSiteDepartment i={i} getSiteDepartment={getSiteDepartment} />
                                                )}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                            {filteredList?.length === 0 && (
                                <tr>
                                    <td colSpan={role !== "ViewAccess" ? 7 : 6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Tag size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Designations Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your search to find what you're looking for.
                                            </p>
                                            {hasActiveFilters && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Search
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};

const EmployeebySiteDesignationTable = ({ designationId, designation, siteSubCompanyList, getSiteDepartment }) => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const role = sessionStorage.getItem('sitemanagement_role');

    const handleClose = () => {
        setShow(false);
        getSiteDepartment();
    };
    const handleShow = () => {
        setShow(true);
        getSiteDepartmentEmployees();
    };

    const [departmentEmployees, setDepartmentEmployees] = useState([]);

    const getSiteDepartmentEmployees = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/employeedetailsbydesignation/${designationId}/active/`
            );
            const getAlphaNumericParts = (code) => {
                const match = code.match(/^([A-Za-z]+)(\d+)$/);
                if (match) {
                    return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
                } else {
                    return { alphaPart: "", numericPart: 0 };
                }
            };

            const sortedList = res.data.sort((a, b) => {
                const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
                const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);
                if (alphaA !== alphaB) return alphaA.localeCompare(alphaB);
                return numericA - numericB;
            });
            setDepartmentEmployees(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const filteredEmployees = departmentEmployees
        ?.filter((e) =>
            e.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            e.emp_code.toString().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => a.emp_code - b.emp_code);

    return (
        <>
            <button className="employee-count-badge-btn" title="View Employees" onClick={handleShow}>
                <Users size={13} />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal request-leave" size="sm">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div style={{ color: "white" }}>
                            <Tag size={22} />

                        </div>
                        <div>
                            <Modal.Title>{designation.title}</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>
                                {departmentEmployees.length} employee{departmentEmployees.length !== 1 ? 's' : ''} assigned
                            </p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <div className="filter-chip" style={{ marginBottom: '16px', maxWidth: '320px' }}>
                        <div className="filter-chip-icon"><Search size={13} /></div>
                        <div className="filter-chip-content" style={{ width: '100%' }}>
                            <span className="filter-chip-label">Search</span>
                            <input
                                className="modern-select"
                                style={{ width: '100%' }}
                                placeholder="Name or Emp Code"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>

                    <div className="table-wrapper-minimal table-box scroll-container-table">
                        {buffer ? (
                            <div className="loader-minimal">
                                <div className="spinner-minimal"></div>
                            </div>
                        ) : (
                            <table className="progress-table-minimal">
                                <thead className="table-heading">
                                    <tr>
                                        <th className="col-sno" style={{ width: '10%' }}>#</th>
                                        <th className="col-period">Emp Code</th>
                                        <th className="col-period">Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredEmployees?.map((i, index) => (
                                        <tr className="progress-row" key={index}>
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <span className="badge-value">{i.emp_code}</span>
                                            </td>
                                            <td className="col-period">{i.name}</td>

                                        </tr>
                                    ))}
                                    {filteredEmployees?.length === 0 && (
                                        <tr>
                                            <td colSpan={role !== "ViewAccess" ? 4 : 3}>
                                                <div className="empty-state-attractive">
                                                    <div className="empty-state-icon-wrap">
                                                        <Users size={32} />
                                                    </div>
                                                    <h4 className="empty-state-title">No Employees Found</h4>
                                                    <p className="empty-state-subtitle">
                                                        {searchQuery ? "Try a different search term." : "No employees assigned to this designation yet."}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const SiteSubcompanyTable = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const role = sessionStorage.getItem('sitemanagement_role');

    const [subCompanyList, setSubCompanyList] = useState([]);
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilters, setShowFilters] = useState(true);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getSiteSubcompanies = async () => {
        setBuffering(true);
        try {
            const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSiteSubCompanyList(sub.data);

            const res = await axios.get(
                `${BASE_URL}/siteproject/subcompanyfilterbysubcompanycount/null/active/`
            );
            setSubCompanyList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getSiteSubcompanies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredList = subCompanyList
        ?.filter((e) => e.title.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title, "en", { ignorePunctuation: true }));

    const hasActiveFilters = searchQuery !== "";

    const clearAllFilters = () => {
        setSearchQuery("");
    };

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div className="filter-chip-icon"><Search size={13} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <span className="filter-chip-label">Search Sub Company</span>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Search Sub Company"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && role === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Tag size={14} />
                        <span>Showing</span>
                        <strong>{(filteredList?.length) || 0} sub companies</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    {PERMISSION_AUTHORITY && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddSiteSubcompanys getSiteSubcompanies={getSiteSubcompanies} />
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '6%' }}>#</th>
                                <th className="col-period">Company Name</th>
                                <th className="col-period text-center">Employee Count</th>
                                <th className="col-approved text-center" style={{ width: '12%' }}>Employees</th>
                                {role !== "ViewAccess" && <th className="col-approved text-center" style={{ width: '12%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList?.map((i, index) => (
                                <tr className="progress-row" key={index}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period">
                                        <span className="badge-value">{i.title}</span>
                                    </td>
                                    <td className="col-period text-center">{i.employee_count}</td>

                                    <td className="col-approved text-center">
                                        <EmployeebySiteSubCompanyTable
                                            subcompany={i}
                                            siteSubCompanyList={siteSubCompanyList}
                                            designationId={i.id}
                                        />
                                    </td>
                                    {role !== "ViewAccess" && (
                                        <td className="col-approved text-center">
                                            <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                <UpdateSiteSubcompanyupdate
                                                    i={i}
                                                    designationId={i.id}
                                                    getSiteSubcompanies={getSiteSubcompanies}
                                                />
                                                {PERMISSION_AUTHORITY && (
                                                    <DeleteSiteSubcompany i={i} getSiteSubcompanies={getSiteSubcompanies} />
                                                )}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                            {filteredList?.length === 0 && (
                                <tr>
                                    <td colSpan={role !== "ViewAccess" ? 5 : 4}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Tag size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Sub Companies Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your search to find what you're looking for.
                                            </p>
                                            {hasActiveFilters && role === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Search
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};


const SiteDepartment = () => {
    const { PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [toggleCompany, setToggleCompany] = useState("null");

    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const role = sessionStorage.getItem('sitemanagement_role');
    const [siteDepartmentList, setSiteDepartmentList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const getSiteDepartment = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSiteSubCompanyList(sub.data);
            const res = await axios.get(`${BASE_URL}/siteproject/department/`);
            setSiteDepartmentList(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };



    useEffect(() => {
        getSiteDepartment();
    }, []);

    return (
        <>
            <div className="attendance-subcontainer margin">
                <div className="field-cont flex-row justify-between" style={{ width: "100%" }}>

                    <div className="flex-row">
                        {PERMISSION_AUTHORITY ? (
                            <>
                                <div title="Sub Compaany" className=" field-cont-div">
                                    <CircularGrid />

                                    <select
                                        onChange={(e) => setToggleCompany(e.target.value)}
                                        style={{ cursor: 'pointer' }}
                                        value={toggleCompany}
                                        className="attendance-input-field width-10vw "
                                    >
                                        <option value="null"> Sub Company</option>
                                        {siteSubCompanyList.map((company) => (
                                            <option value={company.id}>{company.title}</option>
                                        ))}
                                        ;
                                    </select>
                                    <hr className="field-cont-hr" />

                                </div>
                                <div title="Search Department" className="field-cont-div">
                                    <SearchBig />
                                    <input
                                        placeholder="Search Department"
                                        className="attendance-input-field "
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>


                            </>
                        ) : null}


                    </div>
                    <div>

                        <AddDepartment getSiteDepartment={getSiteDepartment} />
                        {role === "Admin" &&
                            <UploadDepartment getdepartment={getSiteDepartment} />
                        }
                    </div>
                </div>
            </div>
            <div className="table-css-white-background">

                <div className="table-box scroll-container-table">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-left-sr">Sr.no</th>
                                <th className="table-heading-text text-center">Department Name</th>
                                <th className="table-heading-text text-center">Company</th>
                                <th className="table-heading-text text-right" style={{ justifyContent: 'right', paddingRight: '40px' }}>Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div> //buffering logic
                        ) : (
                            <tbody>
                                {siteDepartmentList
                                    ?.filter((e) =>
                                        e.title.toLowerCase().includes(searchQuery.toLowerCase())
                                    )
                                    .sort((a, b) =>
                                        a.title.localeCompare(b.title, "en", {
                                            ignorePunctuation: true,
                                        })
                                    )
                                    .map((i, index) => (
                                        <React.Fragment key={index}>

                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-left-sr">{index + 1}</td>
                                                <td className="table-body  text-center">{i.title}</td>
                                                <td className="table-body text-center">{i.sub_company_title}</td>
                                                <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                    <UpdateDepartment
                                                        i={i}
                                                        getSiteDepartment={getSiteDepartment}
                                                    />

                                                    {PERMISSION_AUTHORITY ? (
                                                        <DeleteDepartment
                                                            i={i}
                                                            getSiteDepartment={getSiteDepartment}
                                                        />
                                                    ) : null}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </>
    );
};

const EmployeebySiteSubCompanyTable = ({ designationId, subcompany, siteSubCompanyList }) => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const role = sessionStorage.getItem('sitemanagement_role');

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        getSubCompanyEmployees(subcompany.id);
    };

    const [subcompanyEmployees, setSubCompanyEmployees] = useState([]);
    const [departmentEmployees, setDepartmentEmployees] = useState([]);

    const getSiteDepartmentEmployees = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/employeedetailsbydesignation/${designationId}/active/`
            );
            const getAlphaNumericParts = (code) => {
                const match = code.match(/^([A-Za-z]+)(\d+)$/);
                if (match) {
                    return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
                } else {
                    return { alphaPart: "", numericPart: 0 };
                }
            };

            const sortedList = res.data.sort((a, b) => {
                const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
                const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);
                if (alphaA !== alphaB) return alphaA.localeCompare(alphaB);
                return numericA - numericB;
            });
            setDepartmentEmployees(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getSubCompanyEmployees = async (subcompanyId) => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/employeedetailsbysubcompany/${subcompanyId}/active/`
            );
            const getAlphaNumericParts = (code) => {
                const match = code.match(/^([A-Za-z]+)(\d+)$/);
                if (match) {
                    return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
                } else {
                    return { alphaPart: "", numericPart: 0 };
                }
            };

            const sortedList = res.data.sort((a, b) => {
                const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
                const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);
                if (alphaA !== alphaB) return alphaA.localeCompare(alphaB);
                return numericA - numericB;
            });
            setSubCompanyEmployees(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const filteredEmployees = subcompanyEmployees
        ?.filter((e) =>
            e.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            e.emp_code.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => a.emp_code - b.emp_code);

    return (
        <>
            <button className="employee-count-badge-btn" title="View Employees" onClick={handleShow}>
                <Users size={13} />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal request-leave" size="sm">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div style={{ color: "white" }}>
                            <Tag size={22} />
                        </div>
                        <div>
                            <Modal.Title>{subcompany.title}</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>
                                {subcompanyEmployees.length} employee{subcompanyEmployees.length !== 1 ? 's' : ''} assigned
                            </p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <div className="filter-chip" style={{ marginBottom: '16px', maxWidth: '320px' }}>
                        <div className="filter-chip-icon"><Search size={13} /></div>
                        <div className="filter-chip-content" style={{ width: '100%' }}>
                            <span className="filter-chip-label">Search</span>
                            <input
                                className="modern-select"
                                style={{ width: '100%' }}
                                placeholder="Name or Emp Code"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>

                    <div className="table-wrapper-minimal table-box scroll-container-table">
                        {buffer ? (
                            <div className="loader-minimal">
                                <div className="spinner-minimal"></div>
                            </div>
                        ) : (
                            <table className="progress-table-minimal">
                                <thead className="table-heading">
                                    <tr>
                                        <th className="col-sno" style={{ width: '8%' }}>#</th>
                                        <th className="col-period">Emp Code</th>
                                        <th className="col-period">Name</th>
                                        <th className="col-period text-center">Designation</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredEmployees?.map((i, index) => (
                                        <tr className="progress-row" key={index}>
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <span className="badge-value">{i.emp_code}</span>
                                            </td>
                                            <td className="col-period">{i.name}</td>
                                            <td className="col-period text-center">{i.designation_name || "-"}</td>

                                        </tr>
                                    ))}
                                    {filteredEmployees?.length === 0 && (
                                        <tr>
                                            <td colSpan={role !== "ViewAccess" ? 5 : 4}>
                                                <div className="empty-state-attractive">
                                                    <div className="empty-state-icon-wrap">
                                                        <Users size={32} />
                                                    </div>
                                                    <h4 className="empty-state-title">No Employees Found</h4>
                                                    <p className="empty-state-subtitle">
                                                        {searchQuery ? "Try a different search term." : "No employees assigned to this sub company yet."}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


const SiteEmployeeExcelData = () => {
    const companyId = sessionStorage.getItem("sitemanagement_project_sub_company");
    const projectID = sessionStorage.getItem("sitemanagement_project");
    const [project, setProject] = useState(projectID ? projectID : "null");
    const location = useLocation();

    const [projectList, setProjectList] = useState([]);
    const [subCompany, setSubCompany] = useState(companyId || "null");
    const [division, setDivision] = useState("null");
    const [divisionList, setDivisionList] = useState([]);
    const [SubcompanyList, setSubcompanyList] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [employeeRole, setEmployeeRole] = useState(null);

    const [profession, setProfession] = useState("null");
    const [designation, setDesignation] = useState(null);
    const [designationList, setDesignationList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [buffer, setBuffering] = useState(false);
    const projectIdd = projectID ? projectID : location.state?.project?.id;
    const [roleList, setRoleList] = useState([]);

    const [showFilters, setShowFilters] = useState(true);
    const [activeStatFilter, setActiveStatFilter] = useState("all"); // 'all' | 'active' | 'inactive'
    const [selectedNo, setNo] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const getRoleData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/rolebysubcompany/${subCompany}/`);
            setRoleList(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getRoleData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subCompany]);

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubcompanyList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getSubCompany();
    }, []);

    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${subCompany}/`);
            setDivisionList(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getproject = async () => {
        try {
            const response = await axios.get(
                sessionStorage.getItem("sitemanagement_role") === "AuthorityEngineer"
                    ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem("sitemanagement_emp_id")}/`
                    : sessionStorage.getItem("sitemanagement_role") === "DataEntryOperator"
                        ? `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem("sitemanagement_emp_id")}/`
                        : `${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`
            );
            const sortedList = sortProjects(response.data, "site_prcode");
            setProjectList(sortedList);
        } catch (error) {
            console.error(error);
        }
    };

    const getDesignation = async () => {
        try {
            const responsee = await axios.get(`${BASE_URL}/siteproject/designationfilterbysubcompany/${subCompany}/`);
            setDesignationList(responsee.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getDivision();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subCompany]);

    useEffect(() => {
        getproject();
        getDesignation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subCompany]);

    const getEmployee = async () => {
        setBuffering(true);
        try {
            const ress = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/${companyId}/`);
            setEmployeeData(ress.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, companyId]);

    // Text search filter (emp code / name / email)
    useEffect(() => {
        let data = employeeData;
        if (selectedNo !== "") {
            const lowercaseSelectedName = selectedNo?.toLowerCase();
            data = data.filter((employee) => {
                return (
                    employee.emp_code?.toString()?.toLowerCase()?.includes(lowercaseSelectedName?.toString()) ||
                    employee?.name?.toLowerCase()?.includes(lowercaseSelectedName) ||
                    employee?.email?.toLowerCase()?.includes(lowercaseSelectedName)
                );
            });
        }
        setFilteredData(data);
    }, [selectedNo, employeeData]);

    // Classify every (search-filtered) row as active / inactive
    const classifiedList = filteredData.map((emp) => {
        const status = (emp.employee_status || "").toString().trim().toLowerCase();
        const category = status === "active" ? "active" : status === "inactive" ? "inactive" : "unknown";
        return { ...emp, _category: category };
    });

    const activeCount = classifiedList.filter((e) => e._category === "active").length;
    const inactiveCount = classifiedList.filter((e) => e._category === "inactive").length;

    // Apply the toggle filter for what's actually shown in the table
    const displayList =
        activeStatFilter === "all"
            ? classifiedList
            : classifiedList.filter((e) => e._category === activeStatFilter);

    const handleStatClick = (filterKey) => {
        setActiveStatFilter((prev) => (prev === filterKey ? "all" : filterKey));
    };

    const hasActiveFilters = activeStatFilter !== "all" || selectedNo !== "" || project !== "null";

    const handleClickDownload = () => {
        const formattedData = displayList.map((i) => ({
            "Emp. Code": i.emp_code || "",
            "Name": i.name || "",
            "Email": i.email || "",
            "Mobile No": i.mobile || "",
            "Date of Birth": i.dob || "",
            "Gender": i.gender || "",
            "Qualification": i.qualification || "",
            "Marital Status": i.married_status || "",
            "Emergency Person Name": i.emergency_person_name || "",
            "Emergency Phone Number": i.emergency_phone_number || "",
            "Relation With": i.emergency_relation || "",
            "Aadhaar Card No.": i.aadhaar || "",
            "UAN Number": i.uan || "",
            "PAN No.": i.pan || "",
            "Current Address": i.current_address || "",
            "Emergency Address": i.emergency_address || "",
            "Division": i.division || "",
            "Employee Type": i.employee_type || "",
            "Employment Type": i.employment_type || "",
            "Replacement Deduction": i.replacement_deduction || "",
            "Employee Role": i.emp_role || "",
            "Joining Date": i.joining_date || "",
            "Inactive Date": i.inactive_date || "",
            "Employee Status": i.employee_status || "",
            "Designation": i.designation_name || "",
            "Account Number": i.account_number || "",
            "IFSC Code": i.ifsc_code || "",
            "Bank Name": i.bank_name || "",
            "Bank Address": i.branch_address || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(data, "employee_data.xlsx");
    };

    const roleOption = [
        ...roleList.map((i) => ({
            value: i.role_name,
            label: i.role_name,
        })),
    ];

    const handleRoleChange = (option) => {
        if (!option) {
            setEmployeeRole("null");
        } else {
            setEmployeeRole(option.value);
        }
    };

    return (
        <div className="progress-modern-container">

            {siteRole !== "SiteManagement" && showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive" style={{ padding: "0px" }}>
                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subCompany} />
                            </div>
                        </div>



                        {hasActiveFilters && siteRole === "Admin" && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setNo("");
                                    setProject("null");
                                    setActiveStatFilter("all");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary - clickable toggles, same pattern as MilestoneDetails */}
            <div className="stats-minimal-row" style={{ justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "20px" }}>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "all" ? "stat-active" : ""}`}
                        onClick={() => setActiveStatFilter("all")}
                    >
                        <Users size={14} />
                        <span>Total Employees</span>
                        <strong>{filteredData.length}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "active" ? "stat-active achieved" : ""}`}
                        onClick={() => handleStatClick("active")}
                    >
                        <CheckCircle size={14} />
                        <span>Active</span>
                        <strong>{activeCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "inactive" ? "stat-active skipped" : ""}`}
                        onClick={() => handleStatClick("inactive")}
                    >
                        <XCircle size={14} />
                        <span>Inactive</span>
                        <strong>{inactiveCount}</strong>
                    </div>
                </div>

                {siteRole !== "SiteManagement" && (
                    <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                        <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                            <Filter size={14} />
                            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                            {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                        </button>

                        {siteRole !== "ViewAccess" && (
                            <div className="filter-actions-attractive">
                                <button className="model-button-print" style={{ backgroundColor: "black" }} onClick={handleClickDownload}>
                                    <DownloadCloud size={18} />
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Table - same wrapper/classes as MilestoneDetails */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead>
                            <tr>
                                <th className="col-sno">S.no.</th>
                                <th>Emp. Code</th>
                                <th>Name</th>
                                <th>Department</th>
                                <th>Email</th>
                                <th>Mobile No</th>
                                <th>Date of Birth</th>
                                <th>Gender</th>
                                <th>Qualification</th>
                                <th>Marital Status</th>
                                <th>Emergency Person Name</th>
                                <th>Emergency Phone Number</th>
                                <th>Relation With</th>
                                <th>Aadhaar Card No.</th>
                                <th>UAN Number</th>
                                <th>PAN No.</th>
                                <th>Current Address</th>
                                <th>Emergency Address</th>
                                <th>Division</th>
                                <th>Employee Type</th>
                                <th>Employment Type</th>
                                <th>Replacement Deduction</th>
                                <th>PMS Portal Role</th>
                                <th>Joining Date</th>
                                <th>Inactive Date</th>
                                <th className="text-center">Employee Status</th>
                                <th>Designation</th>
                                <th>Account Number</th>
                                <th>IFSC Code</th>
                                <th>Bank Name</th>
                                <th>Bank Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList.length === 0 ? (
                                <tr>
                                    <td colSpan={31}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Users size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Employee Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                {activeStatFilter !== "all"
                                                    ? "No records match this status. Try a different filter."
                                                    : "Try adjusting your filters or select a different project to view records."}
                                            </p>
                                            {hasActiveFilters && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setNo("");
                                                        setProject("null");
                                                        setActiveStatFilter("all");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                displayList.map((i, index) => {
                                    const statusType =
                                        i._category === "active" ? "approved" : i._category === "inactive" ? "pending" : "warning";
                                    return (
                                        <tr key={index} className={`progress-row  `}>
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td>{i.emp_code || "-"}</td>
                                            <td>{i.name || "-"}</td>
                                            <td>{i.emp_department || "-"}</td>
                                            <td>{i.email || "-"}</td>
                                            <td>{i.mobile || "-"}</td>
                                            <td>{i.dob || "-"}</td>
                                            <td>{i.gender || "-"}</td>
                                            <td>
                                                <div style={{ width: "150px", whiteSpace: "wrap" }}>{i.qualification || "-"}</div>
                                            </td>
                                            <td>{i.married_status || "-"}</td>
                                            <td>{i.emergency_person_name || "-"}</td>
                                            <td>{i.emergency_phone_number || "-"}</td>
                                            <td>{i.emergency_relation || "-"}</td>
                                            <td>{i.aadhaar || "-"}</td>
                                            <td>{i.uan || "-"}</td>
                                            <td>{i.pan || "-"}</td>
                                            <td>
                                                <div style={{ width: "150px", whiteSpace: "wrap" }}>{i.current_address || "-"}</div>
                                            </td>
                                            <td>
                                                <div style={{ width: "150px", whiteSpace: "wrap" }}>{i.emergency_address || "-"}</div>
                                            </td>
                                            <td>{i.division || "-"}</td>
                                            <td>{i.employee_type || "-"}</td>
                                            <td>{i.employment_type || "-"}</td>
                                            <td>{i.replacement_deduction || "-"}</td>
                                            <td>{i.emp_role || "-"}</td>
                                            <td>{i.joining_date || "-"}</td>
                                            <td>{i.inactive_date || "-"}</td>
                                            <td className="text-center">
                                                <span className={`status-badge-minimal ${statusType}`}>
                                                    {i.employee_status || "-"}
                                                </span>
                                            </td>
                                            <td>
                                                <div style={{ width: "150px", whiteSpace: "wrap" }}>{i.designation_name || "-"}</div>
                                            </td>
                                            <td>{i.account_number || "-"}</td>
                                            <td>{i.ifsc_code || "-"}</td>
                                            <td>
                                                <div style={{ width: "100px", whiteSpace: "wrap" }}>{i.bank_name || "-"}</div>
                                            </td>
                                            <td>
                                                <div style={{ width: "150px", whiteSpace: "wrap" }}>{i.branch_address || "-"}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const SiteEmployeeDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const companyId = sessionStorage.getItem("sitemanagement_project_sub_company");
    const projectID = sessionStorage.getItem("sitemanagement_project");

    const [project, setProject] = useState(projectID ? projectID : "null");
    const location = useLocation();

    const [projectList, setProjectList] = useState([]);
    const [subCompany, setSubCompany] = useState("null");
    const [division, setDivision] = useState("null");
    const [divisionList, setDivisionList] = useState([]);
    const [SubcompanyList, setSubcompanyList] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [employeeRole, setEmployeeRole] = useState(null);

    const [profession, setProfession] = useState("null");
    const [designation, setDesignation] = useState(null);
    const [designationList, setDesignationList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [buffer, setBuffering] = useState(false);
    const projectIdd = projectID ? projectID : location.state?.project?.id;
    const [roleList, setRoleList] = useState([]);

    const getRoleData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/rolebysubcompany/${subCompany}/`);
            setRoleList(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getRoleData();
    }, [subCompany]);

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubcompanyList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getSubCompany();
    }, []);

    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${subCompany}/`);
            setDivisionList(response.data);
        } catch (error) {
            alert(error);
        }
    };

    const getproject = async () => {
        try {
            const response = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`
            );
            const sortedList = sortProjects(response.data, "site_prcode");
            setProjectList(sortedList);
        } catch (error) {
            alert(error);
        }
    };

    const getDesignation = async () => {
        try {
            const responsee = await axios.get(`${BASE_URL}/siteproject/designationfilterbysubcompanycount/${division}/active/${subCompany}/`);
            setDesignationList(responsee.data);
        } catch (error) { }
    };

    useEffect(() => {
        getDivision();
    }, [subCompany, division]);

    useEffect(() => {
        if (projectID === null) {
            getproject();
        }
        getproject();
        getDesignation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subCompany]);

    const getEmployee = async () => {
        setBuffering(true);
        try {
            const ress = await axios.get(`${BASE_URL}/siteproject/employeebyfilterss/${project}/${profession}/${selectedStatus}/${subCompany}/${designation}/${employeeRole}/${division}/`);
            setEmployeeData(ress.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, profession, selectedStatus, subCompany, designation, employeeRole, division]);

    const [selectedNo, setNo] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    useEffect(() => {
        applyFilters();
    }, [selectedNo, employeeData]);

    const applyFilters = () => {
        let filteredData = employeeData;
        if (selectedNo !== "") {
            const lowercaseSelectedName = selectedNo?.toLowerCase();
            filteredData = filteredData.filter(employee => {
                const lid = employee.emp_code?.toString()?.toLowerCase()?.includes(lowercaseSelectedName?.toString())
                    || employee?.name?.toLowerCase()?.includes(lowercaseSelectedName)
                    || employee?.email?.toLowerCase()?.includes(lowercaseSelectedName);
                return lid;
            });
        }
        setFilteredData(filteredData);
    };

    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const handleClickDownload = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'EmployeeData');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(data, 'employee_data.xlsx');
    };

    const roleOption = [
        ...roleList.map((i) => ({ value: i.role_name, label: i.role_name })),
    ];

    const handleRoleChange = (option) => {
        if (!option) {
            setEmployeeRole("null");
        } else {
            setEmployeeRole(option.value);
        }
    };

    const hasActiveFilters = subCompany !== "null" || division !== "null" || project !== "null"
        || selectedStatus !== "null" || employeeRole !== "null" && employeeRole !== null
        || profession !== "null" || (designation !== "null" && designation !== null);

    const clearAllFilters = () => {
        if (siteRole !== "SiteManagement") {
            if (companyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c") setSubCompany("null");
            setDivision("null");
        }
        setProject("null");
        setSelectedStatus("null");
        setEmployeeRole("null");
        setProfession("null");
        setDesignation("null");
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);

    const sortedData = useMemo(() => {
        const order = { "Key Professional": 1, "Sub Professional": 2, "Support Staff": 3 };
        return [...(filteredData || [])].sort(
            (a, b) => (order[a.professional_type] || 4) - (order[b.professional_type] || 4)
        );
    }, [filteredData]);

    const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));

    useEffect(() => {
        if (currentPage > totalPages) setCurrentPage(1);
    }, [totalPages, currentPage]);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return sortedData.slice(start, start + itemsPerPage);
    }, [sortedData, currentPage, itemsPerPage]);

    const goToPage = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    };

    // filteredData badalne pe page 1 pe reset
    useEffect(() => {
        setCurrentPage(1);
    }, [filteredData]);

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        {siteRole !== "SiteManagement" && (
                            <>
                                {/* {companyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
                                    <div className={`filter-chip ${subCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                        <div className="filter-chip-content">
                                            <SubCompanyModern toggleCompany={subCompany} setToggleCompany={setSubCompany} cssType="modern" />

                                        </div>
                                    </div>
                                )} */}

                                <div className={`filter-chip ${division !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                    <div className="filter-chip-content">
                                        <DivisionModern division={division} setDivision={setDivision} subCompany={subCompany} cssType="modern" />

                                    </div>
                                </div>
                            </>
                        )}

                        {siteRole !== "SiteManagement" && (
                            <div className={`filter-chip ${project !== "null" ? "" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                <div className="filter-chip-content">
                                    <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subCompany} />
                                </div>
                            </div>
                        )}

                        <div className={`filter-chip ${selectedStatus !== "null" ? "active" : ""}`}>
                            <div ><Activity size={13} className="selector-iconss" /></div>
                            <div className="filter-chip-content">
                                <select
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="null">All</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div className={`filter-chip ${employeeRole && employeeRole !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <Select
                                    className="project-filter-select"
                                    options={roleOption}
                                    value={roleOption.find((i) => i.value === employeeRole) || null}
                                    onChange={handleRoleChange}
                                    placeholder="Select Role"
                                    isClearable={employeeRole !== "null"}
                                    styles={getCSSForFilterDropdown("5")}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </div>

                        <div className={`filter-chip ${profession !== "null" ? "active" : ""}`}>
                            <div ><Briefcase size={13} /></div>
                            <div className="filter-chip-content">
                                <select
                                    value={profession}
                                    onChange={(e) => setProfession(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="null">Professional Type</option>
                                    <option value="Key Professional">Key Professional</option>
                                    <option value="Sub Professional">Sub Professional</option>
                                    <option value="Support Staff">Support Staff</option>
                                </select>
                            </div>
                        </div>

                        <div className={`filter-chip ${designation && designation !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <DesignationModern
                                    cssType="modern"
                                    division={division}
                                    subCompany={subCompany}
                                    designation={designation}
                                    setDesignation={setDesignation}
                                />
                            </div>
                        </div>

                        <div className="filter-chip" style={{ minWidth: '220px' }}>
                            <div className="filter-chip-icon"><Search size={13} /></div>
                            <div style={{ width: '100%' }}>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Name / Emp code / Email"
                                    type="text"
                                    value={selectedNo}
                                    onChange={(e) => setNo(e.target.value)}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && siteRole === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + Actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Users size={14} />
                        <span>Showing</span>
                        <strong>{filteredData.length} employees</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    {siteRole !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>

                            <AddSiteEmployee
                                projectId={project}
                                getSiteEmployee={getEmployee}
                                siteProjectList={projectList}
                                siteDepartmentList={designationList}
                                siteSubCompanyList={divisionList}
                                companyId={subCompany}
                            />
                            <BulkUpdateEmployee getData={getEmployee} project={project} designationList={designationList} toggleSubcompany={subCompany} />
                            <UploadSiteEmployee getSiteEmployee={getEmployee} designation={designationList.title} division={divisionList} ROLE={roleList} />
                        </div>
                    )}
                </div>
            </div>

            <div className="employee-cards-toolbar">
                <span className="employee-cards-count">
                    Showing {sortedData.length === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1}
                    -{Math.min(currentPage * itemsPerPage, sortedData.length)} of {sortedData.length}
                </span>
                <div className="employee-cards-perpage">
                    <label>Per page</label>
                    <select
                        value={itemsPerPage}
                        onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    >
                        <option value={12}>12</option>
                        <option value={24}>24</option>
                        <option value={48}>48</option>
                        <option value={96}>96</option>
                    </select>
                </div>
            </div>

            <div style={{ maxHeight: '65vh', padding: '0 4px', overflowY: 'auto' }}>
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <EmployeeDetailCard
                        data={paginatedData}
                        getSiteEmployee={getEmployee}
                        siteDepartmentList={designationList}
                        companyList={SubcompanyList}
                        siteProjectList={projectList}
                        siteSubCompanyList={divisionList}
                    />
                )}
            </div>

            {totalPages > 1 && (
                <div className="employee-cards-pagination">
                    <button
                        className="pagination-btn"
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: "black", color: "white" }}
                    >
                        <ChevronLeft size={16} /> Prev
                    </button>

                    {getPageNumbers()[0] > 1 && (
                        <>
                            <button className="pagination-btn" onClick={() => goToPage(1)}>1</button>
                            {getPageNumbers()[0] > 2 && <span className="pagination-ellipsis">...</span>}
                        </>
                    )}

                    {getPageNumbers().map((page) => (
                        <button
                            key={page}
                            className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                            style={{ backgroundColor: page === currentPage ? 'black' : 'white', color: page === currentPage ? 'white' : 'black' }}
                            onClick={() => goToPage(page)}
                        >
                            {page}
                        </button>
                    ))}

                    {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
                        <>
                            {getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                            <button className="pagination-btn" onClick={() => goToPage(totalPages)}>{totalPages}</button>
                        </>
                    )}

                    <button
                        className="pagination-btn"
                        style={{ backgroundColor: "black", color: "white" }}
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next <ChevronRight size={16} />
                    </button>
                </div>
            )}
        </div>
    );
};

// const ConsultantAccountDetails = (i) => {
//     const [project, setProject] = useState("null");
//     const [buffer, setBuffering] = useState(false); //buffering logic
//     const [loading, setLoading] = useState(false); //loading logic
//     const [subCompanyList, setSubCompanyList] = useState([]);
//     const [subCompany, setSubCompany] = useState("null")
//     const [subbuffer, setSubBuffering] = useState(true); //buffering logic
//     const [projectList, setProjectList] = useState([]);
//     const { projectID } = usePermission();
//     const [selectedName, setName] = useState("");
//     const [selectedFromDate, setFromDate] = useState('null');
//     const [selectedToDate, setToDate] = useState('null');
//     const [accountList, setAccountList] = useState([]);

//     useEffect(() => {
//         getSubCompany();
//         getAccountDetails();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [projectID, project]);
//     useEffect(() => {
//         getproject();
//     }, [subCompany])

//     const getAccountDetails = async () => {
//         setBuffering(true); // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/consultantaccountdetails/`);
//             setAccountList(res.data);

//         } catch (err) {
//             handleErrorToast(err);

//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };
//     const getproject = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`);

//             const splitCodeParts = (code) => {
//                 const parts = code.trim().split("/");
//                 const firstPart = parts.slice(0, -1).join("/");
//                 const lastPart = parts.pop();
//                 const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
//                 if (match) {
//                     return {
//                         firstPart,
//                         numericPart: match[1] ? parseInt(match[1], 10) : 0,
//                         alphaPart: match[2]
//                     };
//                 }
//                 return { firstPart, numericPart: 0, alphaPart: "" };
//             };

//             const sortedList = response.data.sort((a, b) => {
//                 const aParts = splitCodeParts(a.site_prcode);
//                 const bParts = splitCodeParts(b.site_prcode);
//                 if (aParts.firstPart !== bParts.firstPart) {
//                     return aParts.firstPart.localeCompare(bParts.firstPart);
//                 }
//                 if (aParts.alphaPart !== bParts.alphaPart) {
//                     return aParts.alphaPart.localeCompare(bParts.alphaPart);
//                 }
//                 return aParts.numericPart - bParts.numericPart;
//             });

//             // setProjectList(response.data)
//             setProjectList(sortedList)

//         } catch (error) {
//             alert(error);
//         }
//     }
//     const getSubCompany = async () => {
//         setSubBuffering(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompanyList(res.data);
//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {
//             setSubBuffering(false);// End Buffering
//         }
//     };


//     return (
//         <>

//             <div className="table-css-white-background">

//                 <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
//                     <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
//                         <div className="repo-heading font-weight500    font-size-heading">
//                             Consultant Account Details
//                         </div>
//                         <AddConsultantAccount getConsultant={getAccountDetails} />
//                     </div>
//                     <div className='table-box  scroll-container-table' style={{ width: "100%" }}>
//                         <table className="table-css" >
//                             <thead>
//                                 <tr className="custom-table-head-tr">
//                                     <th className="table-heading-text text-left-sr">S.no.</th>
//                                     {/* <th className="table-heading-text text-center">Company Name</th> */}
//                                     <th className="table-heading-text">Bank Name</th>
//                                     <th className="table-heading-text">IFSC Code</th>
//                                     <th className="table-heading-text">Account number</th>
//                                     <th className="table-heading-text">PAN Number</th>
//                                     <th className="table-heading-text">GST Number</th>
//                                     <th className="table-heading-text">Address</th>
//                                     <th className="table-heading-text">Gst Certificates</th>
//                                     <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
//                                 </tr>
//                             </thead>
//                             {buffer ? (
//                                 <div className="spinner-bgdatil"></div>
//                             ) : (
//                                 <tbody>
//                                     {accountList.map((i, index) => (
//                                         <tr key={index} className="custom-table-head-td">
//                                             <td className="table-body text-left-sr">{index + 1}</td>
//                                             {/* <td className="table-body">{i.company_name}</td> */}
//                                             <td className="table-body">{i.bank_name}</td>
//                                             <td className="table-body">{i.ifsc_code}</td>
//                                             <td className="table-body">{i.account_number}</td>
//                                             <td className="table-body">{i.pan_no}</td>
//                                             <td className="table-body">{i.gst_no}</td>
//                                             <td className="table-body">{i.address}</td>
//                                             <td className="table-body text-center">
//                                                 <a href={i.document} target="blank" className="text-center width-5vw">
//                                                     <DocumentIcon />
//                                                 </a>
//                                             </td>
//                                             <td className="table-body  text-right" style={{ justifyContent: 'right' }} >
//                                                 <UpdateConsultantAccount i={i} getConsultant={getAccountDetails} />
//                                                 <DeleteAccountDetails i={i} getConsultant={getAccountDetails} />
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             )}

//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </>)

// }


const ConsultantAccountDetails = (i) => {
    const [project, setProject] = useState("null");
    const [buffer, setBuffering] = useState(false);
    const [loading, setLoading] = useState(false);
    const [subCompanyList, setSubCompanyList] = useState([]);
    const [subCompany, setSubCompany] = useState("null")
    const [subbuffer, setSubBuffering] = useState(true);
    const [projectList, setProjectList] = useState([]);
    const { projectID } = usePermission();
    const [selectedName, setName] = useState("");
    const [selectedFromDate, setFromDate] = useState('null');
    const [selectedToDate, setToDate] = useState('null');
    const [accountList, setAccountList] = useState([]);
    const [showFilters, setShowFilters] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        getSubCompany();
        getAccountDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectID, project]);
    useEffect(() => {
        getproject();
    }, [subCompany])

    const getAccountDetails = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/consultantaccountdetails/`);
            setAccountList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };
    const getproject = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`);

            const splitCodeParts = (code) => {
                const parts = code.trim().split("/");
                const firstPart = parts.slice(0, -1).join("/");
                const lastPart = parts.pop();
                const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
                if (match) {
                    return {
                        firstPart,
                        numericPart: match[1] ? parseInt(match[1], 10) : 0,
                        alphaPart: match[2]
                    };
                }
                return { firstPart, numericPart: 0, alphaPart: "" };
            };

            const sortedList = response.data.sort((a, b) => {
                const aParts = splitCodeParts(a.site_prcode);
                const bParts = splitCodeParts(b.site_prcode);
                if (aParts.firstPart !== bParts.firstPart) {
                    return aParts.firstPart.localeCompare(bParts.firstPart);
                }
                if (aParts.alphaPart !== bParts.alphaPart) {
                    return aParts.alphaPart.localeCompare(bParts.alphaPart);
                }
                return aParts.numericPart - bParts.numericPart;
            });

            setProjectList(sortedList)
        } catch (error) {
            alert(error);
        }
    }
    const getSubCompany = async () => {
        setSubBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setSubBuffering(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredList = accountList
        ?.filter((e) =>
            (e.bank_name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (e.account_number || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (e.pan_no || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (e.gst_no || "").toLowerCase().includes(searchQuery.toLowerCase())
        );

    const hasActiveFilters = searchQuery !== "";

    const clearAllFilters = () => {
        setSearchQuery("");
    };

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div className="filter-chip-icon"><Search size={13} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <span className="filter-chip-label">Search Account</span>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Bank, Account No., PAN or GST"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && sessionStorage.getItem("sitemanagemwent_role") === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Tag size={14} />
                        <span>Showing</span>
                        <strong>{(filteredList?.length) || 0} accounts</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                        <AddConsultantAccount getConsultant={getAccountDetails} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '6%' }}>#</th>
                                <th className="col-period">Bank Name</th>
                                <th className="col-period text-center">IFSC Code</th>
                                <th className="col-period text-center">Account Number</th>
                                <th className="col-period text-center">PAN Number</th>
                                <th className="col-period text-center">GST Number</th>
                                <th className="col-period text-center">Address</th>
                                <th className="col-approved text-center" style={{ width: '10%' }}>GST Certificate</th>
                                <th className="col-approved text-center" style={{ width: '12%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList?.map((i, index) => (
                                <tr className="progress-row" key={index}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period">
                                        <span className="badge-value">{i.bank_name}</span>
                                    </td>
                                    <td className="col-period text-center">{i.ifsc_code || "-"}</td>
                                    <td className="col-period text-center">{i.account_number || "-"}</td>
                                    <td className="col-period text-center">{i.pan_no || "-"}</td>
                                    <td className="col-period text-center">{i.gst_no || "-"}</td>
                                    <td className="col-period text-center">{i.address || "-"}</td>
                                    <td className="col-approved text-center">
                                        <a href={i.document} target="_blank" rel="noreferrer">
                                            <FileBadge2 size={35} color="black" />
                                        </a>
                                    </td>
                                    <td className="col-approved text-center">
                                        <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                            <UpdateConsultantAccount i={i} getConsultant={getAccountDetails} />
                                            <DeleteAccountDetails i={i} getConsultant={getAccountDetails} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {filteredList?.length === 0 && (
                                <tr>
                                    <td colSpan={9}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Tag size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Accounts Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your search to find what you're looking for.
                                            </p>
                                            {hasActiveFilters && sessionStorage.getItem('sitemanagement_role') === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Search
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};





export {
    SiteDesignationTable,
    SiteSubcompanyTable,
    SiteDepartment,
    SiteEmployeeDetails,
    ConsultantAccountDetails,
    SiteEmployeeExcelData

};
